// expiryStyles.js
import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
`;

export const Trigger = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 100%;
  margin-top: 0;
  border-radius: 8px;
  border: 1px solid ${({ $error }) => ($error ? '#d60000' : '#231f20')};
  padding: 13px 16px;
  outline: none;
  color: #231f20;

  &:focus-within {
    border-color: #008427;
    box-shadow: none;
    outline: none;
  }

  cursor: pointer;

  span.value {
    color: #231f20; /* gray-900 */
  }
  span.placeholder {
    color: #6b7280; /* gray-500 */
  }
`;

export const ChevronDownIcon = styled.div`
  display: inline-flex;
  transition: transform 0.15s ease;
  ${({ $open }) =>
    $open &&
    css`
      transform: rotate(180deg);
    `}
  color: #6b7280; /* gray-500 */
`;

export const Dropdown = styled.div`
  position: absolute;
  z-index: 50;
  width: 20rem; /* w-80 */
  margin-top: 0.25rem;
  background: #fff;
  border: 1px solid #e5e7eb; /* gray-200 */
  border-radius: 0.375rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
`;

export const YearNav = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 0.75rem;
  border-bottom: 1px solid #e5e7eb; /* gray-200 */
`;

export const YearLabel = styled.span`
  font-weight: 600;
  color: #111827; /* gray-900 */
`;

export const IconButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  width: 2rem;
  height: 2rem;
  padding: 0.25rem;

  background: transparent;
  border: none;
  border-radius: 0.375rem;
  cursor: pointer;

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  &:not(:disabled):hover {
    background: #f3f4f6; /* gray-100 */
  }
`;

export const Panel = styled.div`
  padding: 0.75rem;
`;

export const MonthGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.5rem;
`;

export const MonthButton = styled.button`
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  border-radius: 0.375rem;
  border: none;
  cursor: pointer;
  transition: background-color 0.15s ease;

  ${({ $selected }) =>
    $selected &&
    css`
      background: #005d1f;
      color: #fff;
    `}

  ${({ $disabled, $selected }) =>
    $disabled &&
    !$selected &&
    css`
      color: #d1d5db; /* gray-300 */
      cursor: not-allowed;
    `}

  ${({ $disabled, $selected }) =>
    !$disabled &&
    !$selected &&
    css`
      color: #374151; /* gray-700 */
      background: #fff;
      &:hover {
        background: #f3f4f6; /* gray-100 */
      }
    `}
`;
